export default __webpack_public_path__ + "static/media/align-left.a56544b2.svg";